import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Nav.scss';

export default function Nav({ heading, className, children }) {
    const list = React.Children.toArray(children);

    return (
        <div className={classNames(styles.root, className)}>
            {heading && <h2 className={styles.heading}>{heading}</h2>}
            <ul className={styles.list}>
                {list.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>
        </div>
    );
}

Nav.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    heading: PropTypes.string,
};
